"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slider = exports.container = void 0;

var _react = require("@emotion/react");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 8px;\n\n  & > .MuiSlider-rail {\n    background-color: ", ";\n    opacity: 1;\n    height: 8px;\n    border-radius: ", ";\n  }\n  & > .MuiSlider-thumb {\n    height: 32px;\n    width: 32px;\n    &:hover {\n      box-shadow: 0 0 0 4px ", "16;\n    }\n    &.MuiSlider-active {\n      box-shadow: 0 0 0 8px ", "16;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: 90%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var container = (0, _react.css)(_templateObject());
exports.container = container;

var slider = function slider(theme) {
  return (0, _react.css)(_templateObject2(), theme.colors.primary.medium, theme.radii.lg, theme.colors.primary.medium, theme.colors.primary.medium);
};

exports.slider = slider;